
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/SupabaseAuthContext';
import { motion } from 'framer-motion';
import { LogOut } from 'lucide-react';

const Logout: React.FC = () => {
  const { signOut, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        if (isAuthenticated) {
          await signOut();
        }
        // Redirect to home page after logout
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Logout error:', error);
        // Still redirect even if there's an error
        navigate('/', { replace: true });
      }
    };

    performLogout();
  }, [signOut, navigate, isAuthenticated]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-background to-muted">
      <motion.div 
        className="text-center space-y-4"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="inline-block rounded-full bg-blue-100 dark:bg-blue-900/20 p-6">
          <LogOut className="h-8 w-8 text-blue-600 animate-pulse" />
        </div>
        <h2 className="text-xl font-semibold text-foreground">Signing you out...</h2>
        <p className="text-muted-foreground">Please wait while we log you out safely.</p>
      </motion.div>
    </div>
  );
};

export default Logout;
